import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { BreadcrumbDto, GoogleFileDto, GoogleFileRequestDto, ResponseDto, UserDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpFilesService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/files');
	}

	getAllFiles(folderId?: string): Observable<GoogleFileDto[]> {
		var payload = folderId ? {folderId: folderId} : {};
		return super.post(`/get-all`, payload);
	}
	getBreadcrumbs(folderId: string): Observable<BreadcrumbDto[]> {
		return super.get(`/folder/${folderId}/breadcrumbs`);
    }
	packageAndDownload(files: GoogleFileDto[]): Observable<HttpResponse<Blob>> {
        const payload: GoogleFileRequestDto = {
            packageFiles: files
        };
		return super.postBlobWithHeaders('/package-download', payload);
    }

}
